










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import JinroStatisticsTable from "@/components/shared/JinroStatisticsTable.vue";
import { JinroPlayerStatisticsDocument } from "../../services/datatypes";

@Component({
  components: {
    JinroStatisticsTable
  }
})
export default class JinroRoomRanking extends Vue {
  @Prop() readonly playerStatistics!: Array<JinroPlayerStatisticsDocument>;
  @Prop() readonly selectedPlayerId!: string;
  @Prop() readonly timeLastGameEnded!: firebase.firestore.Timestamp;

  get statistics(): Array<JinroPlayerStatisticsDocument> {
    if (!this.playerStatistics) {
      return [];
    }
    return this.playerStatistics;
  }
}
